import { DateTime } from 'luxon';

interface Schedule {
  __typename: string;
  startTime: string | null;
  endTime: string | null;
  allHours: boolean;
  startDate: string | null;
  endDate: string | null;
  daysOfWeek: number[] | null;
}

export const isAreaWithinTheSchedule = (schedule: Schedule): boolean => {
  const now = DateTime.local();

  if (schedule.startDate || schedule.endDate) {
    const startDate = schedule.startDate
      ? DateTime.fromISO(schedule.startDate)
      : null;
    const endDate = schedule.endDate
      ? DateTime.fromISO(schedule.endDate)
      : null;
    if ((startDate && now < startDate) || (endDate && now > endDate)) {
      return false;
    }
  }

  if (schedule.daysOfWeek && !schedule.daysOfWeek.includes(now.weekday)) {
    return false;
  }

  // Check if 24h
  if (schedule.startTime === schedule.endTime) {
    return true;
  }

  const toSeconds = (time: string | null): number => {
    if (!time) return 0;
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const currentSeconds = now.hour * 3600 + now.minute * 60 + now.second;
  const startSeconds = toSeconds(schedule.startTime);
  const endSeconds = toSeconds(schedule.endTime);

  if (endSeconds >= startSeconds) {
    return currentSeconds >= startSeconds && currentSeconds < endSeconds;
  } else {
    return currentSeconds >= startSeconds || currentSeconds < endSeconds;
  }
};
